<template>
  <div style="position:relative">
    <div class="col-4 offset-2" style="position:absolute; z-index:1; opacity:0.15">
        <img src="/images/preview.jpg" height="550px">
    </div>
  </div>
</template>

<script>
export default {
    name: 'PreviewWaterMarks',
}
</script>